import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { Heading, Title } from '@treams/treams-ui';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

import {
	EvaluationFormFragment,
	EvaluationSectionItem,
	useEvaluationFormQuery,
} from 'generated/graphql';

import {
	SelectConversationCardDescription as Description,
	SelectConversationTypeCardQuestion as Question,
	SelectConversationTypeCardSkeleton as Skeleton,
} from '.';

export const SelectConversationTypeCard = ({ id, description, title }: EvaluationFormFragment) => {
	const { localize } = useLocalize();

	const { t } = useTranslation('', {
		keyPrefix: 'evaluations.create.modal.form.selectConversationType.card',
	});

	const { data } = useEvaluationFormQuery({
		variables: { id },
	});

	const questions = data?.evaluationForm.sections.flatMap((section) => {
		return section.items.map((item: EvaluationSectionItem) => {
			return <Question key={item.id} {...item} />;
		});
	});

	const titleLabel = localize(title).text;

	return (
		<Box width="75%" p={5} pt={4}>
			<Title pb={3}>{titleLabel} </Title>
			<Heading pb={1}>{t('description')}</Heading>
			<Description description={description} />
			<Box pt={4} pb={3}>
				<Heading> {t('preview')} </Heading>
				{data ? <ul>{questions}</ul> : <Skeleton />}
			</Box>
		</Box>
	);
};
